import { render, staticRenderFns } from "./Modifybinscore.vue?vue&type=template&id=6acc844e"
import script from "./Modifybinscore.vue?vue&type=script&lang=js"
export * from "./Modifybinscore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports